import PropTypes from 'prop-types';
import React from 'react';

import widgetWrapper from './widgetWrapper';

import './DebugMessageWidget.scss';

const DebugMessageWidget = (props) => {
  return <div className="DebugMessageWidget"><span>{props.message}</span></div>;
};

DebugMessageWidget.propTypes = {
  message: PropTypes.string,
};

DebugMessageWidget.defaultProps = { message: 'MESSAGE' };

export default widgetWrapper(DebugMessageWidget);
